<template>
  <v-row justify="center">
    <v-dialog v-model="open" persistent width="600px">
      <v-card>
        <v-toolbar elevation="0">
          <v-icon color="error">mdi-alert</v-icon>
          <v-toolbar-title class="ml-2 text--subtitle">
            {{ $t('message.pages.uploadErrorModal.title') }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="subtitle-2">
          {{ $t('message.pages.uploadErrorModal.description1') }}<br />
          <br />
          {{ $t('message.pages.uploadErrorModal.description2') }}
        </v-card-text>
        <v-card-actions class="pb-4">
          <v-spacer></v-spacer>
          <v-btn
            text
            class="mr-1"
            min-width="150px"
            @click="handleContactSupport"
          >
            {{ $t('message.pages.uploadErrorModal.action2') }}
          </v-btn>
          <v-btn
            class="primary white--text"
            min-width="150px"
            text
            @click="handleClose"
          >
            {{ $t('message.pages.uploadErrorModal.action1') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'UsageLimit',
  data: () => ({
    open: false,
  }),
  mounted() {
    this.$root.$on('uploadErrorModal', async (data) => {
      Object.assign(this.$data, this.initialState())
      this.open = data.open
    })
  },
  beforeDestroy() {
    this.$root.$off('uploadErrorModal')
  },
  methods: {
    handleContactSupport() {
      this.$crisp.push(['do', 'chat:show'])
      this.$crisp.push(['do', 'chat:open'])
      this.open = false
    },
    handleClose() {
      this.open = false
      this.$root.$emit('resetIsAnyOtherModal')
    },
    initialState() {
      return {
        open: false,
      }
    },
  },
}
</script>
